export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";